module.exports = __webpack_public_path__ + "static/img/169264319.67e7017.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/169264319.jpg
// module id = Dl35
// module chunks = 0